import { cn } from "../../../lib/utils";
import React from "react";
import { ProjectOutline } from "tekkr-common/dist/model/project/project";
import { MergeIcon } from "lucide-react";

type ProjectWorkstream = ProjectOutline["workstreams"][number];

export function ProjectWorkstreamHeader(props: {
    active: boolean;
    ws: Pick<ProjectWorkstream, "id" | "name" | "description">;
    index?: number;
    showDescription?: boolean;
    className?: string;
}) {
    const { ws } = props;
    return (
        <div className={cn("flex flex-row items-center gap-4", props.className)}>
            <ProjectWorkstreamIcon variant={props.active ? "selected" : undefined} ws={ws} index={props.index} />
            <div className={"grow"}>
                <div className={"line-clamp-3 text-base font-medium"}>{ws.name}</div>
                {props.showDescription && <div className={"text-sm text-muted-foreground"}>{ws.description}</div>}
            </div>
        </div>
    );
}

export function ProjectWorkstreamIcon(props: {
    ws: Pick<ProjectWorkstream, "id">;
    index?: number;
    variant?: "selected";
    size?: "xs";
    inline?: boolean;
    className?: string;
}) {
    function content() {
        const id = props.ws.id;
        if (id === "alignment") {
            return <MergeIcon className={cn("h-5 w-5", props.size === "xs" && "h-3.5 w-3.5")} />;
        }
        const label = props.index != null ? String.fromCharCode(65 + props.index) : id;
        return <>{label}</>;
    }
    return (
        <div
            className={cn(
                "flex h-10 w-10 shrink-0 flex-row items-center justify-center rounded-full bg-foreground/5 font-semibold text-foreground/50",
                props.variant === "selected" && "border-2 border-confirmation bg-confirmation/20 text-confirmation",
                props.size === "xs" && "h-6 w-6 text-xs",
                props.inline && "inline-flex",
                props.className
            )}
        >
            {content()}
        </div>
    );
}
